/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * The connection state:
 *   * TO_CONFIGURE
 *   * CONFIGURED
 *   * CONNECTED
 *   * DISCONNECTED
 */
export enum ConnectionState {
  TO_CONFIGURE = 'TO_CONFIGURE',
  CONFIGURED = 'CONFIGURED',
  CONNECTED = 'CONNECTED',
  DISCONNECTED = 'DISCONNECTED'
}
